import { GridFilterModel, GridLinkOperator } from '@material-ui/data-grid'
import create from 'zustand'
import { persist } from 'zustand/middleware'

type MessageActions = {
  setFilter: (props: GridFilterModel) => void
  clearFilterAssistant: () => void
}

type State = GridFilterModel & MessageActions

const initialState: GridFilterModel = { items: [] }

export const useFilterValidationStateAssistant = create<State>(
  persist(
    (set) => ({
      ...initialState,
      setFilter: (props: GridFilterModel) => {
        set({ ...props, linkOperator: GridLinkOperator.And })
      },
      clearFilterAssistant: () => {
        set({
          items: [],
        })
      },
    }),
    {
      name: 'validationFilterAssistant',
    },
  ),
)
